import { useState, useEffect } from "react"
import { Modal, Input, message } from "antd"
import { toggleSongSheet, addMySheet } from "@/common/common"
import { useSnapshot } from "valtio"
import generalStore from "@/store/general"
import sheetStore, { addSheet } from "@/store/mySheet"
import styles from "./css/addSongSheet.modules.less"

const AddSongSheet = () => {
  const [title, setTitle] = useState("新建歌单")
  const [value, setValue] = useState("")
  const [curSheet, setCurSheet] = useState({})
  const [messageApi, content] = message.useMessage()
  const { sheetModal } = useSnapshot(generalStore)
  const { sheetList } = useSnapshot(sheetStore)
  useEffect(() => {
    if (sheetModal.action == "add") {
      setTitle("添加到我的歌单")
    } else {
      setTitle("新建歌单")
    }
  }, [sheetModal.action])
  // 新建歌单
  const createSheet = () => {
    toggleSongSheet(true, "create")
  }
  // 选中歌单
  const selectSheet = (val) => {
    // console.log(val)
    setCurSheet(val)
  }
  // 弹框确认
  const confirm = () => {
    switch (sheetModal.action) {
      // 添加到我的歌单
      case "add":
        if (!curSheet.name) {
          messageApi.open({
            type: "warning",
            content: "请选择歌单"
          })
          return
        }
        let data = addMySheet(curSheet)
        messageApi.open({
          type: data.type,
          content: data.msg
        })
        setCurSheet({})
        break
      // 新建歌单
      case "create":
        if (!value) {
          messageApi.open({
            type: "warning",
            content: "请填写名称"
          })
          return
        }
        let flag = addSheet(value)
        if (!flag) {
          messageApi.open({
            type: "warning",
            content: "该歌单已存在，请重新命名"
          })
          return
        }
        setValue("")
        toggleSongSheet(false)
        messageApi.open({
          type: "success",
          content: "添加歌单成功"
        })
        break
    }
  }
  // 关闭弹窗
  const cancel = () => {
    toggleSongSheet(false)
    setValue("")
  }
  return (
    <div>
      {content}
      <Modal
        className={styles.addSongSheetBox}
        title={title}
        open={sheetModal.flag}
        onOk={confirm}
        onCancel={cancel}
        afterClose={() => toggleSongSheet(false)}
      >
        {sheetModal.action == "add" && (
          <div className="wrap scrollY">
            <ul>
              <li onClick={createSheet}>新建歌单</li>
              {sheetList &&
                sheetList.map((item) => (
                  <li
                    className={curSheet.name === item.name ? "active" : ""}
                    key={item.name}
                    onClick={() => selectSheet(item)}
                  >
                    {item.name}
                  </li>
                ))}
            </ul>
          </div>
        )}
        {sheetModal.action == "create" && (
          <Input
            allowClear
            value={value}
            placeholder="请填写歌单名称"
            onChange={(e) => setValue(e.target.value)}
            onPressEnter={(e) => confirm(e)}
          ></Input>
        )}
      </Modal>
    </div>
  )
}
export default AddSongSheet
